import React, { Fragment, Component } from 'react';
import Dropdown from './dropdown';
import I18n from '~/utils/translations';

const BEDROOM_RANGE = [0, 1, 2, 3, 4, 5];

const BedroomCountRange = (props) => {
  const textFormatter = (i) => (i == 0 ? 'Studio' : i);

  return (
    <div className="preferences-pane bed-range-preferences">
      <span className="preferences-pane__title">{I18n.t('pages.homes.bed_range_preferences.title')}</span>
      <div className="preferences-pane__dropdown-container">
        <Dropdown
          name="minBeds"
          noneSelected="No Min"
          options={BEDROOM_RANGE}
          value={props.minBeds}
          max={props.maxBeds}
          updateSelection={(e) => props.onMinBedsChange(e.target.value)}
          optionTextFormatter={textFormatter}
        />
        <Dropdown
          name="maxBeds"
          noneSelected="No Max"
          options={BEDROOM_RANGE}
          value={props.maxBeds}
          min={props.minBeds}
          updateSelection={(e) => props.onMaxBedsChange(e.target.value)}
          optionTextFormatter={textFormatter}
        />
      </div>
    </div>
  );
};

export default BedroomCountRange;
